import { VideoMeetingChat } from "./VideoMeetingChat";
import { useChatVisibility } from "@platform/hooks/useChatVisibility";
import { useTalkJSData } from "@platform/hooks/useChat";
import { useFetchUserCircles } from "@core/features/circle";
import { usePlatformStore, useVideoMeetingDetails } from "@platform/store";

export function VideoMeetingChatContainer() {
  const user = usePlatformStore((s) => s.user);
  const talkjsData = useTalkJSData();
  const { meetingDetails } = useVideoMeetingDetails();
  const { data: circlesData } = useFetchUserCircles({ user });
  const userCircles = circlesData?.circles ?? null;
  const { shouldShowChat, isLoading } = useChatVisibility({ userCircles });

  // Don't render chat if disabled or still loading
  if (isLoading || !shouldShowChat) {
    return null;
  }

  // The in-meeting tab renders the conversation tied to *this* meeting's
  // circle. The session-init payload carries one entry per
  // chat-eligible circle, each with a numeric `circle_id`; finding the
  // entry that matches `meetingDetails.circle` is the entire selection
  // — no picker, no persistence, no resolver hook. If the meeting's
  // circle isn't in the user's set (chat gated, or upstream
  // provisioning hasn't caught up), the lookup yields null and the
  // presentational component falls through to its empty state.
  const meetingCircleId = meetingDetails?.circle ?? null;
  const conversationId =
    meetingCircleId == null
      ? null
      : talkjsData?.conversations.find(
          (c) => c.circle_id === meetingCircleId
        )?.talkjs_conversation_id ?? null;

  return (
    <VideoMeetingChat
      talkjsData={talkjsData}
      user={user}
      conversationId={conversationId}
    />
  );
}

export default VideoMeetingChatContainer;
